"use strict";

import nn_svg_js from "../../../assert/nn_svg_js";

const defaultFunds = [
  {
    name: "Федеральный бюджет",
    value: 0,
    unit: "млн. руб.",
  },
  {
    name: "Местный бюджет",
    value: 0,
    unit: "млн. руб.",
  },
  {
    name: "Областной бюджет",
    value: 0,
    unit: "млн. руб.",
  },
  {
    name: "Внебюджетные средства",
    value: 0,
    unit: "млн. руб.",
  },
  {
    name: "Кол-во рабочих мест",
    value: 0,
    unit: "шт.",
  },
  {
    name: "Кол-во проектов",
    value: 0,
    unit: "шт.",
  },
];

export default function () {
  return {
    restrict: "A",
    template: require("../view/nn-map.html"),
    scope: {
      isPrint: "=isPrint",
      countByMunicipality: "=countByMunicipality",
      defaultColors: "=defaultColors",
    },
    controller: [
      "$scope",
      "MetricService",
      ($scope, MetricService) => {
        $scope.regions = nn_svg_js;
        $scope.dataCache = {};
        $scope.chartOptions = {
          cutoutPercentage: 70,
          aspectRatio: 1,
          borderWidth: 0,
          animation: false,
          plugins: {
            labels: {
              render: "percentage",
              showZero: false,
              fontStyle: "bold",
              position: "center",
              precision: 1,
              fontColor: "#333",
            },
            radiusBackground: {
              color: "#dcdcdc",
              enabled: true,
            },
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                const { datasets, labels } = data;
                const { index, datasetIndex } = tooltipItem;
                if (!labels[index]) return tooltipItem;
                const labelParts = labels[index].split(",");
                if (!datasets[datasetIndex] || !datasets[datasetIndex].data)
                  return tooltipItem;
                return `${labelParts[0]}: ${datasets[datasetIndex].data[index]} ${labelParts[1]}`;
              },
            },
          },
        };

        $scope.loading = false;
        $scope.selectMunicipality = selectMunicipality;
        $scope.currentRegionAmountFormat = currentRegionAmountFormat;
        $scope.ranksDivider = ranksDivider;
        MetricService.fundsByMunicipality({ municipalityId: null }).then(
          (items) => {
            $scope.mapDefaultData = items;
            if (!$scope.$$phase) {
              $scope.$apply();
            }
          }
        );
        $scope.currentRegion = $scope.selectMunicipality(
          null,
          "",
          $scope.countByMunicipality
        );
        $scope.selectRegion = (region) => {
          if ($scope.currentRegion.id === region.id) {
            $scope.currentRegion = $scope.selectMunicipality(
              null,
              "",
              $scope.countByMunicipality
            );
            return;
          }
          if ($scope.dataCache[region.id]) {
            $scope.currentRegion = $scope.dataCache[region.id];
            return;
          }
          $scope.currentRegion = $scope.selectMunicipality(
            region.id,
            region.name,
            []
          );
          $scope.loading = true;
          MetricService.fundsByMunicipality({ municipalityId: region.id }).then(
            (items) => {
              $scope.currentRegion = $scope.selectMunicipality(
                region.id,
                region.name,
                items
              );
              if ((items || []).length) {
                $scope.dataCache[region.id] = $scope.currentRegion;
              }
              $scope.loading = false;
              $scope.$apply();
            }
          );
        };

        function selectMunicipality(municipalityId, municipalityName, items) {
          const fundItems = validateFundItems(
            items.filter((n) => n.name.includes("бюджет"))
          );
          return {
            id: municipalityId,
            name: municipalityName,
            amount: calcFundSummary(fundItems),
            items: validateFundItems(items),
            chartItems: fundItems.map((n) => n.value || 0),
            chartLabels: fundItems.map((n) => `${n.name},${n.unit}`),
          };
        }

        function validateFundItems(items) {
          return Array.isArray(items) && items.length ? items : defaultFunds;
        }

        function calcFundSummary(fundItems) {
          return {
            value: fundItems.reduce((acc, red) => acc + (red.value || 0), 0),
            unit: fundItems[0].unit,
          };
        }

        function ranksDivider(num) {
          return num ? num.toLocaleString() : 0;
        }

        function currentRegionAmountFormat(value) {
          return Intl.NumberFormat("en-US", {
            maximumFractionDigits: 2,
          }).format(value);
        }

        $scope.$watch(
          "isPrint",
          function (nv, oldv) {
            if (angular.equals(nv, oldv)) return;
            if (!$scope.isPrint) return;
            $scope.currentRegion = $scope.selectMunicipality(
              null,
              "",
              $scope.countByMunicipality
            );
          },
          true
        );

        $scope.$watch(
          "countByMunicipality",
          function (nv, oldv) {
            if (angular.equals(nv, oldv)) return;
            $scope.dataCache = {};
            if ($scope.currentRegion.id !== null) return;
            $scope.currentRegion = $scope.selectMunicipality(
              null,
              "",
              $scope.countByMunicipality
            );
          },
          true
        );
      },
    ],
  };
}
